<template>
    <div class="row">
        <div class="col-md-12 mb-5">
            <h3 class="mb-3 font-weight-bold border-bottom pb-2">【シリアルコード登録・編集】</h3>
            <b-tabs content-class="mt-3">
                <b-tab active>
                    <template v-slot:title>
                        {{ $t('managerForm.settingSerialCode.serialCode') }}
                    </template>
                    <div class="form-group row mb-0">
                        <div class="col-sm-12">
                            <div class="d-flex align-items-center justify-content-between mr-4">
                                <div class="form-group row">
                                    <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{
                                        $t('managerForm.settingSerialCode.importType')
                                    }}</label>
                                    <div class="d-flex flex-wrap mb-2">
                                        <div v-for="item in OPTION_IMPORT_SERIAL_CODE" :key="item.id">
                                            <InputRadio
                                                class="mr-5 mb-2"
                                                :model.sync="radio_import"
                                                :id="`raido-IMPORT${item.id}`"
                                                :name="`radio-IMPORT`"
                                                :value="item.id"
                                                :label="item.name"
                                                :disabled="isView"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <button :disabled="isView" type="button" class="btn btn-secondary" @click="downLoadTemplateSerialCode">
                                        テンプレートダウンロード
                                    </button>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{
                                    $t('managerForm.settingSerialCode.patternSelection')
                                }}</label>
                                <div>
                                    <InputCheckBox
                                        id="checkImportSerialCode"
                                        :model.sync="is_not_use_import"
                                        :value="is_not_use_import"
                                        :disabled="isView"
                                        :label="$t('managerForm.settingSerialCode.notSimilarCharacters')"
                                    />
                                    <ul>
                                        <li v-for="(item, idx) in LIST_NOTE_CHECK_USE_KEY" :key="`tab-import-${idx}`">{{ item.label }}</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="d-flex">
                                <UploadFileCommon
                                    :id="`uploadSerialCode`"
                                    class="mb-2 p-0"
                                    :fileValues.sync="serial_code_file"
                                    :disabled="isView"
                                    :typeUpload="'import'"
                                    :isImportStyle="true"
                                    title="インポート"
                                    :config="{
                                        maxSize: 2048,
                                        allowedExtension: ['csv']
                                    }"
                                    @importFile="
                                        (evt) => {
                                            importedFile = evt;
                                            isErrorFile = false;
                                        }
                                    "
                                />
                                <div class="p-2">
                                    {{ $t('managerForm.settingSerialCode.noteRuleImportSerialCode') }}
                                </div>
                            </div>
                            <div class="d-flex align-items-center mt-2" style="gap: 1rem">
                                <div>
                                    <button
                                        :disabled="isView || !serial_code_file"
                                        type="button"
                                        class="btn btn-primary px-4"
                                        @click="onHandleImportFile"
                                    >
                                        {{ $t('btn.register') }}
                                    </button>
                                </div>
                                <div v-if="isErrorFile" class="text-danger" style="gap: 1rem">
                                    【登録失敗のお知らせ】<br />
                                    シリアルコードごとのエラー内容を記載したファイルを返却しています。内容をご確認のうえ、修正後に再度登録してください。
                                </div>
                                <div v-else>
                                    {{
                                        radio_import === OPTION_IMPORT_SERIAL_CODE[1].id
                                            ? '※登録を実行するたびに新しいシリアルコードが追加されます。'
                                            : '※登録を実行するたびに新しいシリアルコードが上書きされます。'
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                </b-tab>
                <b-tab>
                    <template v-slot:title>
                        {{ $t('managerForm.settingSerialCode.autoGenerationSerialCode') }}
                    </template>
                    <div class="form-group row mb-3">
                        <label class="col-sm-1 text-nowrap" style="min-width: 100px">{{
                            $t('managerForm.settingSerialCode.selectTypeSerialCode')
                        }}</label>
                        <div class="col-sm-9 p-0">
                            <div class="row" style="padding-left: 0.7rem">
                                <div v-for="item in STYLE_IMPORT" :key="item.id">
                                    <InputRadio
                                        class="mr-5 mb-2"
                                        :model.sync="autoSerialCodeinit.type_temp"
                                        :id="`raido-styleImport${item.id}`"
                                        :name="`radio-styleImport`"
                                        :value="item.id"
                                        :label="item.name"
                                        :disabled="isView"
                                    />
                                </div>
                            </div>
                            <div>
                                <InputCheckBox
                                    id="checkNotUseKeyAutoGen"
                                    :model.sync="autoSerialCodeinit.is_not_use_unique_key"
                                    :value="autoSerialCodeinit.is_not_use_unique_key"
                                    :disabled="isView"
                                    :label="$t('managerForm.settingSerialCode.notSimilarCharacters')"
                                />
                                <ul>
                                    <li v-for="(item, idx) in LIST_NOTE_CHECK_USE_KEY" :key="`tab-autogen-${idx}`">{{ item.label }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row mb-3" :key="autoSerialCodeConfig.number_temp.min">
                        <div class="col-sm-12 row" style="gap: 1rem">
                            <div class="form-group row mb-3 col-4">
                                <label class="col-sm-1 text-nowrap" style="min-width: 98px">{{
                                    $t('managerForm.settingSerialCode.numberTitle')
                                }}</label>
                                <div class="col-sm-9">
                                    <InputText
                                        :model.sync="autoSerialCodeinit.number_serial"
                                        :config.sync="autoSerialCodeConfig.number_serial"
                                        :disabled="isView"
                                        @blur="handleValidateField(autoSerialCodeinit.number_serial, autoSerialCodeConfig.number_serial)"
                                    />
                                    <span class="fs-12 text-nowrap">※500万件以上の場合は複数にわけて発行してください。</span>
                                </div>
                            </div>
                            <div class="form-group row mb-3 col-4">
                                <label class="col-sm-6 text-nowrap" style="min-width: 50px">{{
                                    $t('managerForm.settingSerialCode.limitNumberQuantity')
                                }}</label>
                                <div class="col-sm-6">
                                    <InputText
                                        :model.sync="autoSerialCodeinit.quantity_limit"
                                        :config.sync="autoSerialCodeConfig.quantity_limit"
                                        :disabled="isView"
                                        @blur="handleValidateField(autoSerialCodeinit.quantity_limit, autoSerialCodeConfig.quantity_limit)"
                                    />
                                    <span class="fs-12 text-nowrap"
                                        >{{
                                            $t('managerForm.settingSerialCode.noteNumberLimit', {
                                                maxLength: autoSerialCodeConfig.quantity_limit.maxlength
                                            })
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 row">
                            <div class="form-group row col-4">
                                <label class="text-nowrap col-sm-1" style="min-width: 98px">{{
                                    $t('managerForm.settingSerialCode.serialCodeOfDigits')
                                }}</label>
                                <div class="col-sm-9">
                                    <InputText
                                        style="min-width: 180px"
                                        :model.sync="autoSerialCodeinit.number_temp"
                                        :config.sync="autoSerialCodeConfig.number_temp"
                                        :disabled="isView"
                                        @blur="handleValidateField(autoSerialCodeinit.number_temp, autoSerialCodeConfig.number_temp)"
                                    />
                                    <span class="fs-12 text-nowrap">{{
                                        `※桁数は${autoSerialCodeConfig.number_temp.min}から${autoSerialCodeConfig.number_temp.max}までの数値を入力してください。`
                                    }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row mb-3">
                        <div class="col-sm-12 ml-3 d-flex align-items-center" style="gap: 1rem">
                            <button :disabled="isView || isLoadingAutoGen" type="button" class="btn btn-primary px-4" @click="onHandleAutoSerialCode">
                                {{ $t('managerForm.settingSerialCode.generate') }}
                            </button>
                            ※生成を実行するたびに新しいシリアルコードが追加されます。
                        </div>
                    </div>
                </b-tab>
                <b-tab>
                    <template v-slot:title>
                        {{ $t('managerForm.settingSerialCode.individualSerialCodeRegistration') }}
                    </template>
                    <div class="d-flex flex-wrap" style="gap: 1rem">
                        <div class="form-group row col-5 p-0">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{
                                $t('managerForm.settingSerialCode.individualSerialCodeRegistration')
                            }}</label>
                            <div class="col-sm-9">
                                <InputText
                                    :model.sync="serialCodeinit.serial_code"
                                    :config.sync="serialCodeConfig.serial_code"
                                    :disabled="isView"
                                    @change="onHandleChangeInput('serial_code')"
                                    @blur="handleValidateField(serialCodeinit.serial_code, serialCodeConfig.serial_code, 'charSet')"
                                />
                                <div v-if="serialCodeConfig.serial_code.error" class="invalid-feedback d-block">
                                    <span>{{ serialCodeConfig.serial_code.errorText }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row col-4 p-0">
                            <label class="col-sm-6 text-nowrap" style="min-width: 50px">{{
                                $t('managerForm.settingSerialCode.limitNumberQuantity')
                            }}</label>
                            <div class="col-sm-6">
                                <InputText
                                    style="min-width: 150px"
                                    :model.sync="serialCodeinit.quantity_limit"
                                    :config.sync="serialCodeConfig.quantity_limit"
                                    :disabled="isView"
                                    @blur="handleValidateField(serialCodeinit.quantity_limit, serialCodeConfig.quantity_limit)"
                                    @change="
                                        (evt) => {
                                            if (regexNumberZeroMore(evt)) serialCodeinit.quantity_limit = '0';
                                        }
                                    "
                                />
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-1 text-nowrap" style="min-width: 120px"></label>
                        <div class="col-sm-9">
                            {{ $t('managerForm.settingSerialCode.noteCharacterSpecial') }}
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-sm-1 text-nowrap" style="min-width: 120px">パターン選択</label>
                        <div class="col-sm-9">
                            <InputCheckBox
                                id="checkInitHand"
                                :model.sync="serialCodeinit.is_not_use_unique_key"
                                :value="serialCodeinit.is_not_use_unique_key"
                                :disabled="isView"
                                :label="$t('managerForm.settingSerialCode.notSimilarCharacters')"
                            />
                            <ul class="mb-3">
                                <li v-for="(item, idx) in LIST_NOTE_CHECK_USE_KEY" :key="`tab-hand-${idx}`">{{ item.label }}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="d-flex align-items-center" style="gap: 1rem">
                        <button :disabled="isView" type="button" class="btn btn-primary px-4" @click="onHandleAddOneSericode">
                            {{ $t('btn.register') }}
                        </button>
                        ※登録を実行するたびに新しいシリアルコードが追加されます。
                    </div>
                </b-tab>
            </b-tabs>
        </div>
        <div class="col-md-12">
            <h3 class="mb-3 font-weight-bold border-bottom pb-2">【登録済みシリアルコード一覧】</h3>
            <div class="form-group row mb-0">
                <div class="col-sm-12">
                    <div class="col-12 p-0">
                        <div class="text-right mb-3 d-flex align-items-center" style="gap: 10px">
                            <p class="font-weight-bold mb-0">
                                {{ $t('managerForm.settingSerialCode.totalNumber') }}: {{ toLocaleStringTotalSerialCode }}
                            </p>
                            <div class="ml-auto">
                                <button
                                    :disabled="isView || !formSerialCode.serial_codes?.length"
                                    type="button"
                                    class="btn btn-secondary mr-3"
                                    @click="downloadSerialCodeUsed"
                                >
                                    データダウンロード
                                </button>
                                <button
                                    :disabled="!formSerialCode.serial_codes?.length || isView || isLoadingDeleteAllSerial"
                                    type="button"
                                    class="btn btn-danger"
                                    @click="onHandleDeleteAll"
                                >
                                    {{ $t('managerForm.settingSerialCode.deleteAllImportSerialCode') }}
                                </button>
                            </div>
                        </div>
                        <TableListComponent
                            :id="`listOfRegisteredSerialCodes`"
                            :dataList="formSerialCode.serial_codes"
                            :isLoading="tableImportConfig.isLoadingListSerial"
                            :configPage.sync="tableImportConfig.configPage"
                            @onChangePage="$emit('callGetListSerial')"
                        >
                            <template #colgroup>
                                <col v-for="(item, kCol) in CONFIG_TABLE_IMPORT.headers" :key="kCol" :style="{ width: item.width + 'px' }" />
                            </template>
                            <template #head>
                                <tr>
                                    <th v-for="(item, idx) in CONFIG_TABLE_IMPORT.headers" :key="idx" :style="`width: ${item.width}px`">
                                        <div class="el-table__cell">
                                            {{ item.label }}
                                        </div>
                                    </th>
                                </tr>
                            </template>
                            <template #row="{ row, index }">
                                <tr>
                                    <td class="text-left">
                                        <div class="el-table__cell">{{ index }}</div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell">{{ row.serial_code }}</div>
                                    </td>
                                    <td class="text-left">
                                        <InputText
                                            :id="`quantity_limit-${index}`"
                                            :model.sync="row.quantity_limit"
                                            :config="{
                                                maxlength: 5,
                                                isNumber: true,
                                                error: false
                                            }"
                                            :disabled="isView || isLoadingDeleteAllSerial"
                                            @change="onHandleQuantityLimit(row)"
                                        />
                                    </td>
                                    <td class="text-left">
                                        {{ row?.remaining_quantity?.toString() ? row.remaining_quantity : row.quantity_limit }}
                                    </td>
                                </tr>
                            </template>
                        </TableListComponent>
                    </div>
                </div>
            </div>
        </div>
        <ModalCommon
            :id="`ModalImportSerialCode`"
            :config="CONFIG_TABLE_IMPORT.configModalProgressSerialCode"
            @close="() => (CONFIG_TABLE_IMPORT.configModalProgressSerialCode.model = false)"
        >
            <div v-if="isProcessing" class="d-flex justify-content-center">
                <div>
                    <LoadingIcon class="d-flex justify-content-center mb-3" />
                    <!-- <h5 v-if="CONFIG_TABLE_IMPORT.configModalProgressSerialCode.title_excute === 'exportSerial'">
                        {{ $t('common.processDownload') }}
                        <span>({{ downloadProgress }}%)</span>
                    </h5> -->
                    <h5
                        v-if="
                            ['deleteSerial', 'exportSerial', 'autoGenSerial', 'importSerial'].includes(
                                CONFIG_TABLE_IMPORT.configModalProgressSerialCode.title_excute
                            )
                        "
                        class="text-center"
                    >
                        {{ $t('common.systemIsProcessing') }}
                    </h5>
                </div>
            </div>
        </ModalCommon>
    </div>
</template>

<script>
import UploadFileCommon from '@/components/Uploads/Files/main.vue';
import TableListComponent from '@/components/TableList/main.vue';
import runJobMinxin from '@/mixins/runJobMinxin';
import ModalCommon from '@/components/Modal/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';

import { managerFormMethods } from '@/state/helpers';
import { InputRadio, InputText, InputCheckBox } from '@/components/Input';
import {
    OPTION_IMPORT_SERIAL_CODE,
    STYLE_IMPORT,
    CONFIG_TABLE_IMPORT,
    initFormSerialCode,
    configSerialCode,
    objectSerialCode,
    initAutoSerialCode,
    configAutoSerialCode,
    onHandleDuplicateSerialCode,
    onHandleExitSerial,
    validateByCharSet,
    validateNotSimilarCharacters,
    LIST_NOTE_CHECK_USE_KEY
} from '@/views/pages/phase2/manager-form/components/setting-serial-code/constants';
import { validateField, validateAllField } from '@/utils/validate_v2';
import { showMessage } from '@/utils/messages';
import { handleDownFile } from '@/utils/format';
import { regexNumberZeroMore } from '@/utils/regex';
import { onHandleShowConfirm, formatNumberLocale } from '@/utils/handlers';
import { ID_PAGE_TYPE } from '@/views/pages/phase2/manager-form/constants';

export default {
    name: 'ImportSerialCode',
    components: {
        UploadFileCommon,
        InputRadio,
        InputText,
        InputCheckBox,
        TableListComponent,
        ModalCommon,
        LoadingIcon
    },
    props: {
        dataForm: {
            type: Object,
            default: () => {}
        },
        inforForm: {
            type: Object,
            default: () => ({})
        },
        isView: {
            type: Boolean,
            default: () => false
        },
        tableImportConfig: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        toLocaleStringTotalSerialCode() {
            return formatNumberLocale(this.tableImportConfig.configPage.totalSerialCode || 0);
        }
    },
    data() {
        return {
            OPTION_IMPORT_SERIAL_CODE,
            STYLE_IMPORT,
            CONFIG_TABLE_IMPORT,
            LIST_NOTE_CHECK_USE_KEY,
            formSerialCode: this.dataForm,
            serialCodeinit: initFormSerialCode(),
            serialCodeConfig: configSerialCode(),
            autoSerialCodeinit: initAutoSerialCode(),
            autoSerialCodeConfig: configAutoSerialCode(),
            radio_import: OPTION_IMPORT_SERIAL_CODE[0].id,
            serial_code_file: null,
            is_not_use_import: false,
            importedFile: null,
            listSerialCodeImport: [],
            isLoadingDownSerialUsed: false,
            isLoadingAutoGen: false,
            isLoadingImport: false,
            isErrorFile: false,
            isLoadingCreateSerial: false,
            isProcessing: false,
            downloadProgress: 0,
            isLoadingDeleteAllSerial: false,
            copySerialStatusInterval: null,
            isStopCheckStatusSerial: false
        };
    },
    mixins: [runJobMinxin],
    methods: {
        ...managerFormMethods,
        regexNumberZeroMore,

        handleSerialCode(file) {
            this.$emit('dataFile', file);
        },

        async downloadSerialCodeUsed() {
            if (!this.formSerialCode.serial_codes.length || this.isLoadingDownSerialUsed || this.isProcessing) return;
            this.CONFIG_TABLE_IMPORT.configModalProgressSerialCode.model = true;
            this.CONFIG_TABLE_IMPORT.configModalProgressSerialCode.title_excute = 'exportSerial';
            this.isProcessing = true;
            this.isLoadingDownSerialUsed = true;
            try {
                const onProgress = (r, t, p) => {
                    this.downloadProgress = p;
                };
                const dataDown = await this.downloadListSerialCode({
                    form_id: this.inforForm.id
                });
                if (dataDown?.status && dataDown?.data?.file_id) {
                    let successCallback = async (res) => {
                        this.downloadProgress = 100;
                        await handleDownFile(res?.path, res?.file_name, onProgress).catch(() => {
                            showMessage(400, this.$bvToast, this.$t('system.error'));
                        });
                        showMessage(200, this.$bvToast, 'ダウンロード処理が完了しました。');
                        this.isProcessing = false;
                        this.downloadProgress = 0;
                        this.isLoadingDownSerialUsed = false;
                    };
                    let errorCallback = (res) => {
                        showMessage(400, this.$bvToast, this.$t(res?.data?.error_message || 'system.error'));
                        this.isProcessing = false;
                        this.downloadProgress = 0;
                        this.isLoadingDownSerialUsed = false;
                    };
                    await this.startPollingJobStatus(dataDown?.data?.file_id, successCallback, errorCallback, {
                        ...dataDown?.data
                    });
                } else {
                    showMessage(dataDown?.code || 400, this.$bvToast, this.$t(dataDown?.message || 'system.error'));
                    this.isProcessing = false;
                    this.downloadProgress = 0;
                    this.isLoadingDownSerialUsed = false;
                }
            } catch (error) {
                console.log(error);
                this.isProcessing = false;
                this.downloadProgress = 0;
                this.isLoadingDownSerialUsed = false;
            }
        },

        downLoadTemplateSerialCode() {
            const headers = ['シリアルコード', 'シリアルコード利用制限回数'];
            const BOM = '\uFEFF';
            const csvContent = BOM + headers.join(',') + '\n';
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.setAttribute('href', url);
            link.setAttribute('download', 'serial_code_template.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        async onHandleAddOneSericode() {
            let isValid = validateAllField(this.serialCodeinit, this.serialCodeConfig);
            if (isValid) {
                isValid =
                    this.onHandleValidCharSet(
                        this.serialCodeinit.serial_code,
                        this.serialCodeConfig.serial_code,
                        this.serialCodeinit.is_not_use_unique_key
                    ) && isValid;
            }
            let isDuplicate = false;
            if (this.serialCodeinit.serial_code) {
                isDuplicate = onHandleDuplicateSerialCode(this.formSerialCode.serial_codes, this.serialCodeinit.serial_code);
                if (isDuplicate) showMessage(400, this.$bvToast, 'シリアルコードは既に登録されています。');
            }
            if (!isValid || isDuplicate || this.isLoadingCreateSerial) return;
            this.isLoadingCreateSerial = true;
            try {
                const dataRes = await this.createSerialCode({
                    form_id: this.inforForm.id,
                    data: {
                        serial_code: this.serialCodeinit.serial_code,
                        quantity_limit: this.serialCodeinit.quantity_limit
                    }
                });
                if (!dataRes || !dataRes?.status) {
                    this.isLoadingCreateSerial = false;
                    showMessage(400, this.$bvToast, this.$t(dataRes?.message || 'system.error'));
                    return;
                }
                this.serialCodeinit = initFormSerialCode();
                this.serialCodeConfig = configSerialCode();
                showMessage(200, this.$bvToast, '個別シリアルが登録されました。');
                this.$emit('callGetListSerial');
            } catch (error) {
                console.log(error);
            } finally {
                this.isLoadingCreateSerial = false;
            }
        },

        async onHandleQuantityLimit(row) {
            if (!row.quantity_limit?.length || regexNumberZeroMore(row.quantity_limit)) row.quantity_limit = '0';
            try {
                const dataUpdate = await this.updateSerialCode({
                    form_id: this.inforForm.id,
                    serial_id: row.id,
                    data: {
                        quantity_limit: row.quantity_limit
                    }
                });
                if (!dataUpdate || !dataUpdate?.status) {
                    showMessage(200, this.$bvToast, 'Lỗi sửa serial');
                    return;
                }
                this.$emit('callGetListSerial');
            } catch (error) {
                console.log(error);
            }
        },

        async onHandleDeleteAll() {
            const confirm = await onHandleShowConfirm({
                title: '',
                text: '全て削除してよろしいですか。'
            });
            if (confirm) {
                this.CONFIG_TABLE_IMPORT.configModalProgressSerialCode.model = true;
                this.CONFIG_TABLE_IMPORT.configModalProgressSerialCode.title_excute = 'deleteSerial';
                this.isProcessing = true;
                this.isLoadingDeleteAllSerial = true;
                try {
                    const dataDelete = await this.deleteSerialCode({ form_id: this.inforForm.id });
                    if (!dataDelete || !dataDelete.status) {
                        this.isProcessing = false;
                        showMessage(dataDelete?.code || 400, this.$bvToast, this.$t(dataDelete?.message || 'system.error'));
                        return;
                    }
                    let successCallback = async () => {
                        showMessage(200, this.$bvToast, '全削除が完了しました。');
                        this.$emit('callGetListSerial');
                        this.isLoadingDeleteAllSerial = false;
                        this.isProcessing = false;
                    };
                    let errorCallback = (dataDelete) => {
                        let serverMsg = dataDelete?.data?.message || dataDelete?.message;
                        showMessage(400, this.$bvToast, serverMsg);
                        this.isLoadingDeleteAllSerial = false;
                        this.isProcessing = false;
                    };
                    await this.startPollingJobStatus(
                        {
                            form_id: this.inforForm.id,
                            batch_id: dataDelete?.data?.batch_id
                        },
                        successCallback,
                        errorCallback,
                        {
                            ...dataDelete?.data
                        },
                        'deleteSerial'
                    );
                } catch (error) {
                    this.isProcessing = false;
                    showMessage(error?.code, this.$bvToast, error?.message);
                    this.isLoadingDeleteAllSerial = false;
                }
            }
        },
        onCheckTypeTemp(typeId) {
            switch (typeId) {
                case STYLE_IMPORT[1].id:
                    this.autoSerialCodeConfig.number_temp.min = 2;
                    break;
                case STYLE_IMPORT[2].id:
                    this.autoSerialCodeConfig.number_temp.min = 3;
                    break;
                default:
                    this.autoSerialCodeConfig.number_temp.min = 1;
            }
            if (this.autoSerialCodeinit.number_temp?.toString()) {
                this.autoSerialCodeConfig.number_temp.error = false;
                this.handleValidateField(this.autoSerialCodeinit.number_temp, this.autoSerialCodeConfig.number_temp);
            }
        },

        handleValidateField(valueField, configField, keyValid = null) {
            let isValidate = validateField(valueField, configField);
            if (isValidate) {
                if (keyValid === 'charSet') {
                    this.onHandleValidCharSet(valueField, configField, this.serialCodeinit.is_not_use_unique_key);
                }
            }
        },

        onHandleValidCharSet(fielValue, configField, checkNotSimilarCharacters = false) {
            let isCheck = true;
            const trimmedValue = fielValue ? String(fielValue).trim() : '';
            if (!trimmedValue) return isCheck;
            // Kiểm tra khoảng trắng
            if (/\s/.test(trimmedValue)) {
                configField.error = true;
                configField.errorText = '入力された英数字に、システム上で使用が制限されている類似文字、または空白が含まれています。';
                return false;
            }
            if (!validateByCharSet(trimmedValue)) {
                configField.error = true;
                configField.errorText =
                    'シリアルコードは、数字のみ、または半角英数字のみ、もしくは「_」「@」「#」「-」を含む半角英数字で入力してください。';
                isCheck = false;
            }

            if (checkNotSimilarCharacters) {
                if (!validateNotSimilarCharacters(trimmedValue)) {
                    configField.error = true;
                    configField.errorText = '入力された英数字に、システム上で使用が制限されている類似文字、または空白が含まれています。';
                    isCheck = false;
                }
            }

            return isCheck;
        },

        async onHandleAutoSerialCode() {
            let isValid = validateAllField(this.autoSerialCodeinit, this.autoSerialCodeConfig);
            if (!isValid) return;

            const handleErrorMessage = (msg) => {
                const ERROR_KEY = 'serial_quantity.serial_quantity_exceeded.max';
                if (typeof msg === 'string' && msg.startsWith(ERROR_KEY)) {
                    const [, max] = msg.split(':');
                    return `数字のみ・桁数${Number(this.autoSerialCodeinit.number_temp)}では、最大${Number(max)}件まで生成可能です`;
                }
                return msg;
            };

            let payload = {
                form_id: this.inforForm.id,
                serial_quantity: this.autoSerialCodeinit.number_serial ? Number(this.autoSerialCodeinit.number_serial) : null,
                quantity_limit: this.autoSerialCodeinit.quantity_limit ? Number(this.autoSerialCodeinit.quantity_limit) : null,
                type: this.autoSerialCodeinit.type_temp,
                quantity_character: this.autoSerialCodeinit.number_temp ? Number(this.autoSerialCodeinit.number_temp) : null,
                is_not_use_unique_key: this.autoSerialCodeinit.is_not_use_unique_key || false
            };
            if (this.isLoadingAutoGen || this.isProcessing) return;
            this.CONFIG_TABLE_IMPORT.configModalProgressSerialCode.model = true;
            this.CONFIG_TABLE_IMPORT.configModalProgressSerialCode.title_excute = 'autoGenSerial';
            this.isProcessing = true;
            this.isLoadingAutoGen = true;
            try {
                const dataRes = await this.autoGenSerialCode(payload);
                if (!dataRes || !dataRes.status) {
                    const formattedMsg = handleErrorMessage(dataRes?.message);
                    showMessage(dataRes?.code || 400, this.$bvToast, this.$t(formattedMsg || 'system.error'));
                    this.isLoadingAutoGen = false;
                    this.isProcessing = false;
                    return;
                }
                let successCallback = async () => {
                    showMessage(200, this.$bvToast, 'シリアルコードの自動生成に成功しました。');
                    this.$emit('callGetListSerial');
                    this.isLoadingAutoGen = false;
                    this.isProcessing = false;
                };
                let errorCallback = (dataRes) => {
                    let serverMsg = dataRes?.data?.message || dataRes?.message;
                    serverMsg = handleErrorMessage(serverMsg);
                    showMessage(400, this.$bvToast, serverMsg);
                    this.isLoadingAutoGen = false;
                    this.isProcessing = false;
                };
                await this.startPollingJobStatus(
                    {
                        form_id: this.inforForm.id,
                        batch_id: dataRes?.data?.batch_id
                    },
                    successCallback,
                    errorCallback,
                    {
                        ...dataRes?.data
                    },
                    'autoGenSerial'
                );
            } catch (error) {
                showMessage(error?.code, this.$bvToast, error?.message);
            } finally {
                this.isLoadingAutoGen = false;
                this.isProcessing = false;
            }
        },

        async onHandleImportFile() {
            if (this.isLoadingImport || this.isProcessing) return;
            this.CONFIG_TABLE_IMPORT.configModalProgressSerialCode.model = true;
            this.CONFIG_TABLE_IMPORT.configModalProgressSerialCode.title_excute = 'importSerial';
            this.isProcessing = true;
            this.isLoadingImport = true;
            this.listSerialCodeImport = [];
            const formData = new FormData();
            formData.append('file', this.importedFile);
            formData.append('type', this.radio_import);
            formData.append('is_not_use_unique_key', this.is_not_use_import || false);
            let payload = {
                formId: this.inforForm.id,
                formData
            };
            try {
                const dataImport = await this.importSerialCode(payload);
                if (!dataImport || !dataImport.status) {
                    showMessage(400, this.$bvToast, this.$t(dataImport?.message ? dataImport?.message : dataImport?.errors[0] || 'system.error'));
                    this.isLoadingImport = false;
                    this.serial_code_file = null;
                    this.isProcessing = false;
                    return;
                }
                let successCallback = async (resImport) => {
                    this.listSerialCodeImport = resImport.data || [];
                    if (this.radio_import === OPTION_IMPORT_SERIAL_CODE[0].id) {
                        this.formSerialCode.serial_codes = this.listSerialCodeImport.map((item, idx) => {
                            return {
                                ...objectSerialCode(item),
                                make_id: idx + 1
                            };
                        });
                    } else if (this.radio_import === OPTION_IMPORT_SERIAL_CODE[1].id) {
                        this.listSerialCodeImport.forEach((item) => {
                            onHandleExitSerial(this.formSerialCode.serial_codes, item);
                        });
                    }
                    showMessage(200, this.$bvToast, 'インポートが正常に完了しました。');
                    this.radio_import = OPTION_IMPORT_SERIAL_CODE[0].id;
                    this.is_not_use_import = false;
                    this.serial_code_file = null;
                    this.importedFile = null;
                    this.isErrorFile = false;
                    this.isLoadingImport = false;
                    this.isProcessing = false;
                    this.$emit('callGetListSerial');
                };
                let errorCallback = (res) => {
                    if (res?.data?.error_file_url) {
                        this.isErrorFile = true;
                        showMessage(400, this.$bvToast, 'ファイル内のエラーを修正して、再度インポートしてください。');
                        handleDownFile(res?.data?.error_file_url, res?.data?.error_file_name || `error-serial ${Date.now()}`);
                    }
                    if (res?.data?.validation_errors?.length > 0) {
                        res?.data?.validation_errors.forEach((item) => {
                            showMessage(400, this.$bvToast, this.$t(item));
                        });
                    }
                    this.isLoadingImport = false;
                    this.serial_code_file = null;
                    this.isProcessing = false;
                };
                await this.startPollingJobStatus(
                    {
                        form_id: this.inforForm.id,
                        batch_id: dataImport?.data?.batch_id
                    },
                    successCallback,
                    errorCallback,
                    {
                        ...dataImport?.data
                    },
                    'importSerial'
                );
            } catch (error) {
                showMessage(200, this.$bvToast, error.message);
                this.serial_code_file = null;
                this.importedFile = null;
                this.isProcessing = false;
            } finally {
                this.isLoadingImport = false;
                this.isProcessing = false;
            }
        },

        onHandleChangeInput(key) {
            this.serialCodeinit[key] = this.serialCodeinit[key]?.trim();
        },

        onResetData() {
            this.autoSerialCodeinit = initAutoSerialCode();
            this.autoSerialCodeConfig = configAutoSerialCode();
            if (this.copySerialStatusInterval) {
                clearInterval(this.copySerialStatusInterval);
                this.copySerialStatusInterval = null;
            }
        },

        async onHandleCheckStatusSerial() {
            if (this.isStopCheckStatusSerial) {
                return;
            }
            if (this.copySerialStatusInterval) {
                clearInterval(this.copySerialStatusInterval);
                this.copySerialStatusInterval = null;
            }
            try {
                const dataRes = await this.checkStatusCopySerial({
                    form_id: this.$route.query.id
                });
                if (!dataRes || !dataRes?.status) {
                    this.isStopCheckStatusSerial = true;
                    return false;
                }
                const status = dataRes?.data?.status;
                if (['failed', 'completed'].includes(status)) {
                    this.isStopCheckStatusSerial = true;
                    return true;
                }
                if (['pending', 'processing'].includes(status)) {
                    this.isProcessing = true;
                    if (this.CONFIG_TABLE_IMPORT?.configModalProgressSerialCode) {
                        this.CONFIG_TABLE_IMPORT.configModalProgressSerialCode.model = true;
                        this.CONFIG_TABLE_IMPORT.configModalProgressSerialCode.title_excute = 'autoGenSerial';
                    }
                    this.copySerialStatusInterval = setInterval(async () => {
                        try {
                            const pollRes = await this.checkStatusCopySerial({
                                form_id: this.$route.query.id
                            });
                            if (pollRes?.status) {
                                const pollStatus = pollRes?.data?.status;
                                if (pollStatus === 'completed') {
                                    this.isStopCheckStatusSerial = true;
                                    clearInterval(this.copySerialStatusInterval);
                                    this.copySerialStatusInterval = null;
                                    this.isProcessing = false;
                                    if (this.CONFIG_TABLE_IMPORT?.configModalProgressSerialCode) {
                                        this.CONFIG_TABLE_IMPORT.configModalProgressSerialCode.model = false;
                                        this.CONFIG_TABLE_IMPORT.configModalProgressSerialCode.title_excute = '';
                                    }
                                    this.$emit('callGetListSerial');
                                }
                            }
                        } catch (err) {
                            console.error(err);
                        }
                    }, 5000);
                }
                return true;
            } catch (error) {
                return false;
            }
        }
    },
    beforeDestroy() {
        if (this.copySerialStatusInterval) {
            clearInterval(this.copySerialStatusInterval);
            this.copySerialStatusInterval = null;
        }
    },
    mounted() {
        if (Number(this.$route.query.tab) === 2 && this.inforForm?.page_type?.id === ID_PAGE_TYPE.B) {
            this.onHandleCheckStatusSerial();
        }
    },
    watch: {
        dataForm: {
            handler(newVal) {
                this.formSerialCode = newVal;
            },
            immediate: true,
            deep: true
        },

        'formSerialCode.serial_codes': {
            handler() {
                this.$emit('update:dataForm', this.formSerialCode);
            },
            immediate: true,
            deep: true
        },

        'autoSerialCodeinit.type_temp': {
            handler(newVal) {
                this.onCheckTypeTemp(newVal);
            }
        },

        isProcessing: {
            handler(val) {
                if (this.CONFIG_TABLE_IMPORT.configModalProgressSerialCode) {
                    this.$set(this.CONFIG_TABLE_IMPORT.configModalProgressSerialCode, 'hideCloseButton', val);
                }

                if (!val) {
                    this.CONFIG_TABLE_IMPORT.configModalProgressSerialCode.model = false;
                }
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep {
    .nav-tabs {
        border-bottom: none;

        .nav-item {
            .nav-link {
                color: #333;
                background-color: #fff;
                border: 1px solid #dee2e6;
                margin-right: -1px;
                border-radius: 0;
                font-weight: bold;
                padding: 10px 20px;

                &.active {
                    color: #5664d2;
                    background-color: #dadad9;
                    border-bottom: 2px solid #5664d2;
                }
            }
        }
    }

    .tab-content {
        border: 1px solid #dee2e6;
        padding: 20px;
        background-color: #fff;
        margin-top: -1px;
    }
}
</style>
